export class AreaSalesforceModel {
  public role: any[] = [];
  public udb: any[] = [];
  public area: any[] = [];
  public cdc: any[] = [];
  public manager: any[] = [];
  public notes: string;
}
